v-container
  v-row
    v-col(cols="12")
      h3 {{ $t('patient.familyHistory.title') }}

  v-table
    thead
      tr
        th {{ $t('patient.familyHistory.relation') }}
        th {{ $t('patient.familyHistory.medicalEyeDisease') }}
        th {{ $t('patient.familyHistory.causeOfDeath') }}
    tbody
      for member, index in familyHistory
        tr(:key="index")
          td {{ member.relation }}
          td
            v-text-field(
              v-model="member.medicalEyeDisease"
              density="compact"
              hide-details
              variant="outlined"
            )
          td
            v-text-field(
              v-model="member.causeOfDeath"
              density="compact"
              hide-details
              variant="outlined"
            )
